import { FOOTER_CTA, FOOTER_NAV, HERO_COUNTER, LEGAL_NAV, SITE } from '../../data/site';
import { SiteButton } from './SiteButton';
import { SiteBrand } from './SiteBrand';

function FooterNavLink({ href, label }: { href: string; label: string }) {
  return (
    <a href={href} className="footer-menu">
      <span className="footer-menu__label">{label}</span>
      <span className="footer-menu__index" aria-hidden="true">
        →
      </span>
    </a>
  );
}

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <div className="footer-area">
      <section className="footer">
        <div className="footer-atmosphere" aria-hidden="true">
          <span className="footer-atmosphere__grid" />
          <span className="footer-atmosphere__ring footer-atmosphere__ring--a" />
          <span className="footer-atmosphere__ring footer-atmosphere__ring--b" />
          <span className="footer-atmosphere__mark">JOIN HELLO GWIJI</span>
        </div>

        <div className="container">
          <div className="footer-wrap">
            <div className="footer-stage">
              <div className="footer-panel footer-panel--cta">
                <p className="footer-eyebrow">{FOOTER_CTA.eyebrow}</p>
                <h3 className="footer-headline text-white">{FOOTER_CTA.headline}</h3>
                <hr className="footer-divider" aria-hidden="true" />
                <p className="footer-lead">{SITE.tagline}</p>
                <p className="footer-note">{SITE.description}</p>
                <div className="footer-button-wrap">
                  <SiteButton href="/waitlist" variant="light">
                    {FOOTER_CTA.button}
                  </SiteButton>
                </div>
              </div>

              <div className="footer-panel footer-panel--pages">
                <div className="footer-nav-label">Pages</div>
                <hr className="footer-divider" aria-hidden="true" />
                <ul className="footer-menu-list">
                  {FOOTER_NAV.map((link) => (
                    <li key={link.href}>
                      <FooterNavLink href={link.href} label={link.label} />
                    </li>
                  ))}
                </ul>
              </div>

              <div className="footer-panel footer-panel--legal">
                <div className="footer-nav-label">Legal</div>
                <hr className="footer-divider" aria-hidden="true" />
                <ul className="footer-menu-list">
                  {LEGAL_NAV.map((link) => (
                    <li key={link.href}>
                      <FooterNavLink href={link.href} label={link.label} />
                    </li>
                  ))}
                </ul>
              </div>

              <div className="footer-panel footer-panel--stat">
                <div className="footer-stat">
                  <span className="footer-stat__value">
                    {HERO_COUNTER.prefix}
                    {HERO_COUNTER.value}
                    {HERO_COUNTER.suffix}
                  </span>
                  <span className="footer-stat__label">{HERO_COUNTER.label}</span>
                </div>
                <div className="footer-stat__meta">
                  <span className="footer-brand-location">{SITE.location}</span>
                  <a href={`mailto:${SITE.supportEmail}`} className="footer-brand-email">
                    {SITE.supportEmail}
                  </a>
                </div>
              </div>
            </div>

            <div className="footer-brand-strip">
              <a href="/" className="footer-brand w-inline-block" aria-label={`${SITE.name} home`}>
                <SiteBrand variant="footer" />
              </a>
              <div className="copyright-wrap">
                <div className="tag copyright-text">
                  © {year} {SITE.name}. All rights reserved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
